import { useEffect, useState } from "react";
import "./SurveyBuilder.css";
import SurveyBuilder from "./SurveyBuilder";
import { useLocation } from "react-router";
import {
  buildUpdatePayloadFromSurveyJson,
  mapReceivedIds,
  notifyError,
  notifyFormSucess,
  notifyUpdateSuccess,
  transformSurveyJson,
} from "./helper";
import BeatLoader from "react-spinners/BeatLoader";
import {
  createQuestion,
  getQuestionnaireByIdService,
  updateQuestionnaireService,
} from "./services/dataService";

const QuestionBuilderSurveyForm = () => {
  const questionnaireId = useLocation()?.state?.id;
  const questionnaireTitle = useLocation()?.state?.name;
  const [surveyJson, setSurveyJson] = useState(null);
  const [unchangedJson, setUnchangedJson] = useState(null);
  const [loadData, setLoadData] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (questionnaireId) {
      getQuestionnaireJson(questionnaireId);
    }
  }, [questionnaireId]);

  // console.log("UnchangedJson", unchangedJson);

  const saveJson = async () => {
    try {
      setLoad(true);
      const surveyArray = transformSurveyJson(surveyJson, questionnaireId);
      // console.log(surveyArray, "transform");
      const res = await createQuestion(surveyArray);
      if (res?.data?.status === "Success") {
        notifyFormSucess();
        const updata = await getQuestionnaireJson(questionnaireId);
        updateQuestionnaire(updata);
      }
      // console.log("Response", res);
    } catch (err) {
      console.log("Error: ", err?.message);
    } finally {
      setLoad(false);
    }
    // console.log("Transformed Array==>", surveyArray);
  };

  // const getQuestionnaireJson = async (questionnaireId) => {
  //   try {
  //     setLoad(true);
  //     const res = await getQuestionnaireByIdService(questionnaireId);
  //     console.log("Res41", res);
  //     if (
  //       res?.data?.status === "Success" &&
  //       res?.data?.result &&
  //       res?.data?.result?.length > 0 &&
  //       res?.data?.totalCount !== 0
  //     ) {
  //       const lastItem = res?.data?.result?.length - 1;
  //       const json = JSON.parse(res?.data?.result[0]?.json);
  //       console.log("JsonGot", json);
  //       const enrichedJson = mapReceivedIds(json, res?.data?.result);
  //       setLoadData(res?.data?.result);
  //       setSurveyJson(enrichedJson);
  //       setUnchangedJson(enrichedJson);
  //     } else if (
  //       res?.data?.status === "Success" &&
  //       res?.data?.result &&
  //       res?.data?.result?.length === 0 &&
  //       res?.data?.totalCount === 0
  //     ) {
  //       setUnchangedJson(null);
  //       setSurveyJson(null);
  //     }
  //   } catch (err) {
  //     console.log("Error: ", err);
  //     notifyError(err?.message);
  //   } finally {
  //     setLoad(false);
  //   }
  // };

  const getQuestionnaireJson = async (questionnaireId) => {
    try {
      setLoad(true);
      const res = await getQuestionnaireByIdService(questionnaireId);
      // console.log("Res41", res);

      if (
        res?.data?.status === "Success" &&
        res?.data?.result &&
        res?.data?.result?.length > 0 &&
        res?.data?.totalCount !== 0
      ) {
        const json = JSON.parse(res?.data?.result[0]?.json);
        // console.log("JsonGot", json);

        const enrichedJson = mapReceivedIds(json, res?.data?.result);

        // ---- UI State binding
        setLoadData(res?.data?.result);
        setSurveyJson(enrichedJson);
        setUnchangedJson(enrichedJson);

        // ---- Business logic return
        return {
          json: enrichedJson,
          loadData: res?.data?.result,
        };
      } else if (
        res?.data?.status === "Success" &&
        res?.data?.result &&
        res?.data?.result?.length === 0 &&
        res?.data?.totalCount === 0
      ) {
        setUnchangedJson(null);
        setSurveyJson(null);

        return {
          json: null,
          loadData: [],
        };
      }
    } catch (err) {
      console.log("Error: ", err);
      notifyError(err?.message);

      return null;
    } finally {
      setLoad(false);
    }
  };

  // console.log("LoadData", loadData);

  const updateQuestionnaire = async (data) => {
    try {
      setLoad(true);
      const transformData = buildUpdatePayloadFromSurveyJson(
        data?.json,
        data?.json,
        questionnaireId,
        data?.loadData,
      );
      const res = await updateQuestionnaireService(transformData);
      if (res?.data?.status === "Success") {
      }
    } catch (err) {
      notifyError(err?.message);
      console.log("Error: ", err);
    } finally {
      setLoad(false);
    }
  };

  const doubleUpdateFlow = async () => {
    try {
      setLoad(true);

      // ---- First update
      const transformData1 = buildUpdatePayloadFromSurveyJson(
        unchangedJson,
        surveyJson,
        questionnaireId,
        loadData,
      );
      await updateQuestionnaireService(transformData1);

      // ---- Fetch fresh data
      const fresh = await getQuestionnaireJson(questionnaireId);

      if (!fresh) return;

      // ---- Second update using FRESH data
      const transformData2 = buildUpdatePayloadFromSurveyJson(
        unchangedJson,
        fresh.json, // fresh enriched json
        questionnaireId,
        fresh.loadData, // fresh ids
      );

      await updateQuestionnaireService(transformData2);

      notifyUpdateSuccess();
    } catch (err) {
      notifyError(err?.message);
    } finally {
      setLoad(false);
    }
  };

  return (
    <div
      style={{
        margin: "1%",
      }}
    >
      <div className="page">
        <header className="page-header">
          <div className="header-left">
            <div>
              <div className="eyebrow">Questionnaire Builder</div>
              <div className="title">{questionnaireTitle}</div>
            </div>
          </div>
          {!load && (
            <div className="header-actions">
              {unchangedJson === null ? (
                <button
                  style={{
                    width: "7vw",
                  }}
                  className="primary"
                  onClick={saveJson}
                >
                  Save
                </button>
              ) : (
                <button
                  style={{
                    width: "7vw",
                  }}
                  className="primary"
                  onClick={() => {
                    // updateQuestionnaire();
                    doubleUpdateFlow();
                  }}
                >
                  Update
                </button>
              )}
            </div>
          )}
        </header>
      </div>
      {load ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <BeatLoader color="#3661eb" />
        </div>
      ) : (
        <SurveyBuilder
          questionnaireId={questionnaireId}
          setSurveyJson={setSurveyJson}
          surveyJson={surveyJson}
          setLoad={setLoad}
          loadQuestionData={getQuestionnaireJson}
          showDeleteButton={unchangedJson !== null}
        />
      )}
    </div>
  );
};

export default QuestionBuilderSurveyForm;
